(function () {
    'use strict';

    /*
     UserAddressListController
    -------------------------------------------------------------------------- */

    angular
        .module('UserApp.Addresslist', [])
        .controller('UserAddressListController', [
            '$scope',
            '$state',
            '__DataStore',
            '__Form',
            'appServices',
            '__Utils',
            '$rootScope',
            UserAddressListController
        ]);

    /**
      * UserAddressListController handle address form & send request to server
      * to get list of address. 
      *
      * @inject scope
      * @inject $state
      * @inject __DataStore
      * @inject __Form
      * @inject appServices
      * @inject __Utils
      * 
      * @return void
      *-------------------------------------------------------- */

    function UserAddressListController($scope, $state, __DataStore, __Form, appServices, __Utils, $rootScope) {

        var scope = this;
        scope = __Form.setup(scope, 'user_address_form', 'addressData');
        scope.ngDialogData = $scope.ngDialogData;
        scope.pageStatus = false;

        /**
          * get details of addresses
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.getAddresses = function () {

            __DataStore
                .fetch('user.get.addresses')
                .success(
                    function (responseData) {

                        //scope.message = responseData.data.message;
                        appServices.processResponse(
                            responseData,
                            null,
                            function (reactionCode) {

                                var requestData = responseData.data;

                                if (requestData.getRoute === document.location.href) {
                                    var pageType = "noDialog";
                                } else {
                                    var pageType = "dialog";

                                    scope.selectAddress = scope.ngDialogData.selectedAddressID;
                                    scope.addressType = scope.ngDialogData.addressType;
                                    scope.addressSameAs = scope.ngDialogData.addressSameAs;
                                    scope.couponAmt = scope.ngDialogData.couponAmt;

                                };

                                scope.addressData = requestData;
                                scope.pageStatus = true;
                                scope.addressprimary = true;
                                scope.pageType = pageType;

                                if (!_.isEmpty(scope.ngDialogData)) {
                                    scope.selectAddress = scope.ngDialogData.selectedAddressID;
                                    scope.addressType = scope.ngDialogData.addressType;
                                    scope.addressSameAs = scope.ngDialogData.addressSameAs;
                                    scope.couponAmt = scope.ngDialogData.couponAmt;
                                } else {
                                    scope.selectAddress = "";
                                    scope.addressType = "";
                                    scope.addressSameAs = "";
                                    scope.couponAmt = 0;
                                }

                            });
                    });
        }

        scope.getAddresses();


        $rootScope.$on('changeAddresses', function (events, resposeData) {

            if (resposeData.status) {
                scope.addressType = resposeData.addressType;
            };

        });


        /**
          * address add dialog
          *
          * @param number pageType
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.addAddress = function (pageType, selectedAddressID, addressType) {

            if (pageType == "dialog") {

                $scope.closeThisDialog({

                    showAddDialog: true,
                    pageType: pageType,
                    selectedAddressID: selectedAddressID,
                    addressType: addressType

                });

            } else {

                appServices.showDialog(scope,
                    {
                        templateUrl: __globals.getTemplateURL(
                            'user.add-address'
                        )
                    }, function (promiseObj) {


                        if (_.has(promiseObj.value, 'address_added')
                            && promiseObj.value.address_added === true) {
                            scope.addressType = promiseObj.value.addressType;
                            scope.getAddresses();
                        }

                    });
            }

        }

        /**
          * address edit dialog
          *
          * @param number pageType
          * @param number addressID
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.editAddress = function (pageType, addressID, selectedAddressID, addressType) {

            if (pageType == "dialog") {

                $scope.closeThisDialog({
                    showEditDialog: true,
                    addressID: addressID,
                    selectedAddressID: selectedAddressID,
                    addressType: addressType
                });


            } else {

                __DataStore.fetch({
                    'apiURL': 'user.fetch.address.support.data',
                    'addressID': addressID
                })
                    .success(function (responseData) {

                        scope.address = responseData.data.address;
                        appServices.showDialog(scope,
                            {
                                templateUrl: __globals.getTemplateURL(
                                    'user.edit-address'
                                )
                            }, function (promiseObj) {

                                if (_.has(promiseObj.value, 'address_updated')
                                    && promiseObj.value.address_updated == true) {
                                    scope.getAddresses();
                                }

                            });

                    });

            }
        }

        /**
          * Delete address 
          *
          * @param number addressID
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.delete = function (addressID, addressType) {

            __globals.showConfirmation({
                text: __globals.getJSString('address_delete_text'),
                confirmButtonText: __globals.getJSString('delete_action_button_text')
            }, function () {

                __DataStore.post({
                    'apiURL': 'user.address.delete',
                    'addressID': addressID,
                })
                    .success(function (responseData) {

                        var message = responseData.data.message,
                            addressOBJ = {
                                status: true,
                                addressType: addressType,
                                addressID: addressID
                            };

                        appServices.processResponse(responseData, {
                            error: function (data) {
                                __globals.showConfirmation({
                                    title: __globals.getJSString('confirm_error_title'),
                                    text: message,
                                    type: 'error'
                                });

                            }
                        },
                            function (data) {

                                __globals.showConfirmation({
                                    title: __globals.getJSString('confirm_error_title'),
                                    text: message,
                                    type: 'success'
                                });

                                $('#address_' + addressID).fadeOut('slow', function () {
                                    $(this).remove();
                                    scope.getAddresses();
                                });

                                $rootScope.$emit('changeAddress', addressOBJ);   // reload datatable

                            }
                        );

                    });

            });

        };

        /**
          * Close dialog and return promise object
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.close = function () {

            var billingAddressOBJ = {
                status: false,
            };
            $rootScope.$emit('changeAddress', billingAddressOBJ);
            $scope.closeThisDialog({ address_list: true });

        }

        /**
          * get primary address 
          *
          * @param number addressID
          * @param number primary
          * @param number pageType
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.primaryAddress = function (addressID, primary, pageType) {

            scope.addressData.primary = primary;

            scope.updateURL = {
                'apiURL': 'user.get primary.address',
                'addressID': addressID
            };

            __Form.process(scope.updateURL, scope)
                .success(function (responseData) {

                    var message = responseData.data.message;
                    /*addressOBJ  = {
                      status          : true
                          };*/
                    appServices.processResponse(responseData, null,
                        function (data) {
                            scope.getAddresses();
                        	/*if (pageType == 'dialog') {
                        		$scope.closeThisDialog({address_list : true})
                        	};*/
                            //$rootScope.$emit('changePrimaryAddress', addressOBJ);
                        }
                    );

                });
        }

		/**
          * select address for address 
          *
          * @param number addressID
          * @param number addressType
          * @param number addressSameAs
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.selectAddressForOrder = function (addressID, addressType, addressSameAs) {

            __DataStore.fetch({
                'apiURL': 'user.get.address.for.order',
                'addressID': addressID,
                'couponAmt': scope.couponAmt
            })
                .success(function (responseData) {

                    appServices.processResponse(responseData, null,
                        function (data) {

                            var addressOBJ = {

                                status: true,
                                addressSameAs: addressSameAs,
                                responseData: responseData.data,
                                addressType: addressType,
                                totalOrder: responseData.data.shipping
                            };

                            if (addressType == 'billing') {


                                var billingAddressOBJ = {
                                    status: false,
                                    addressType: 'billing',
                                    totalOrder: responseData.data.shipping
                                };
                                $rootScope.$emit('changeAddress', billingAddressOBJ);

                            };

                            if (addressSameAs == false && addressType != 'billing') {
                                $rootScope.$emit('changeAddressInOrder', addressOBJ);
                            } else {

                                $rootScope.$emit('changeAddressInOrder', addressOBJ);
                            }

                            $scope.closeThisDialog({ address_list: true });
                        }
                    );
                });

        }


    };

})();